class LocalWishlist {
  constructor() {
    this.key = "sh-wl";
    this.count = 0;

    this.init();
    this.registerEvents();
  }

  init() {
    if (localStorage.getItem(this.key) === null) {
      this.set([]);
      return;
    }

    this.sync();
  }

  registerEvents() {
    document.querySelectorAll('[ref="Wishlist:open"]').forEach((element) => {
      element.addEventListener("click", this.open.bind(this));
    });
  }

  get() {
    return JSON.parse(localStorage.getItem(this.key));
  }

  set(entries = []) {
    localStorage.setItem(this.key, JSON.stringify(entries));
    this.count = entries.length;
    publish(PUB_SUB_EVENTS.wishlistUpdate, {
      count: this.count,
    });
  }

  has(handle) {
    const items = this.get();
    return items.indexOf(handle) != -1;
  }

  count() {
    return this.count;
  }

  handleItem(handle) {
    let feedback;
    let items = this.get();
    if (items.indexOf(handle) != -1) {
      items = items.filter((item) => {
        return item !== handle;
      });
      feedback = "removed";
    } else {
      items.push(handle);
      feedback = "added";
    }
    this.set(items);
    return feedback;
  }

  getWishlistUrl(initial = false) {
    const items = this.get()
      .map((item) => `id:${item}`)
      .join(" OR ");
    return `/search?section_id=wishlist${
      initial == true ? "&initial=true" : ""
    }&type=product&options[unavailable_products]=show&q=${items}`;
  }

  sync() {
    fetch(this.getWishlistUrl(true))
      .then((response) => response.text())
      .then((responseText) => {
        let entries = [];
        const initialList = new DOMParser()
          .parseFromString(responseText, "text/html")
          .getElementById("Wishlist-InitialList");
        if (initialList) {
          entries = initialList.querySelectorAll("li");
        }
        const wishlist = [];
        entries.forEach((entry) => {
          wishlist.push(entry.textContent);
        });
        this.set(wishlist);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  open(event) {
    if (event) event.preventDefault();

    fetch(this.getWishlistUrl())
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const dialog = html.querySelector("dialog");
        const body = document.documentElement.querySelector('body');
        body.appendChild(dialog);
        dialog.showModal();
        document.documentElement.classList.add("overflow-hidden");
        dialog.addEventListener("click", (event) => {
          if (
            event.target === dialog ||
            event.target.classList.contains("dialog-close") ||
            event.target.closest(".dialog-close")
          ) {
            dialog.close();
            dialog.remove();
            document.documentElement.classList.remove("overflow-hidden");
          }
        });
        Array.from(dialog.querySelectorAll(".dialog-close")).forEach(
          (element) => {
            element.addEventListener("click", (event) => {
              event.preventDefault();
              dialog.close();
              document.documentElement.classList.remove("overflow-hidden");
              document.body.dispatchEvent(new CustomEvent("modalClosed"));
            });
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
window.Wishlist = new LocalWishlist();

class WishlistCounter extends HTMLElement {
  constructor() {
    super();

    this.onWishlistUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.wishlistUpdate,
      this.handleWishlistUpdate.bind(this)
    );

    this.inner = this.querySelector(".count");
  }

  handleWishlistUpdate(data) {
    if (this.inner) {
      this.inner.textContent = data.count;
    }
  }
}
customElements.define("wishlist-counter", WishlistCounter);

class WishlistButton extends HTMLElement {
  constructor() {
    super();

    this.status = false;
    this.productId = this.dataset.productId;
    this.productCard = this.closest("product-card");
    this.context = this.productCard ? this.productCard.dataset.context : null;
    this.text = this.querySelector(".text-content");
    this.init();
  }

  init() {
    this.addEventListener("click", this.onClick.bind(this));
    this.classList.add("initialized");
    this.setState(Wishlist.has(this.productId));
  }

  onClick(event) {
    event.preventDefault();

    const result = Wishlist.handleItem(this.productId);
    if (result === "removed" && this.context === "wishlist") {
      const listElement = this.productCard.closest("ul");
      this.productCard.closest("li").remove();
      document
        .querySelectorAll(
          `wishlist-button[data-product-id="${this.productId}"]`
        )
        .forEach((element) => element.setState(false));
      if (listElement.childElementCount == 0) {
        document.getElementById("Wishlist").classList.add("empty");
      }
      return;
    }

    //this.setState(result == "added");
    // are there others?
    document
      .querySelectorAll(`wishlist-button[data-product-id="${this.productId}"]`)
      .forEach((button) => {
        button.setState(result == "added");
      });
  }

  setState(status) {
    this.status = status;

    if (this.status === true) {
      this.classList.add("added-to-wishlist");
      this.style.color = this.dataset.active;
    } else {
      this.classList.remove("added-to-wishlist");
      this.style.color = this.dataset.inactive;
    }

    this.setText();
  }

  setText() {
    if (!this.text) return;
    this.text.textContent =
      this.status == true
        ? Theme.translations.wishlist_action_remove
        : Theme.translations.wishlist_action_add;
  }
}
customElements.define("wishlist-button", WishlistButton);
